module.exports = __webpack_public_path__ + "images/buitenlandsebezoekercoma_small740bd7c4105171f6247bc81b7cab247a.png";